angular.module('cian.mapDraw', ['cian.geoService', 'cian.ui.button'])
.config(["$interpolateProvider", function ($interpolateProvider) {
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
}])
.constant('IMAGES_CONST', {
  PIN: '/static/images/search_map_pin.png',
  PIN_HOVER: '/static/images/search_map_pin_hover.png'
})
.constant('YMAPS_PRESETS_CONST', {
  POLYGON: {
    draggable: true,
    strokeColor: '#7a7a7a',
    fillColor: '#ffffff',
    strokeWidth: 2,
    fillOpacity: 0.6,
    editorDrawingCursor: 'crosshair',
    editorVertexLayout: 'polygonVertexLayout',
    editorEdgeLayout: 'polygonEdgeLayout'
  },
  POLYGON_HIGHLIGHTED: {
    draggable: true,
    strokeColor: '#007aeb',
    fillColor: '#007aeb',
    strokeWidth: 2,
    fillOpacity: 0.3,
    editorDrawingCursor: 'crosshair',
    editorVertexLayout: 'polygonVertexLayout',
    editorEdgeLayout: 'polygonEdgeLayout'
  },
  CIRCLE: {
    draggable: true,
    strokeColor: '#7a7a7a',
    fillColor: '#ffffff',
    strokeWidth: 2,
    fillOpacity: 0.6
  },
  CIRCLE_HIGHLIGHTED: {
    draggable: true,
    strokeColor: '#007aeb',
    fillColor: '#007aeb',
    strokeWidth: 2,
    fillOpacity: 0.3
  },
  PIN: {
    iconLayout: 'default#image',
    iconImageHref: '/static/images/search_map_pin.png',
    iconImageSize: [26, 26],
    iconImageOffset: [-13, -32]
  },
  PIN_INVISIBLE: {
    iconLayout: 'default#image',
    iconImageHref: '/static/images/search_map_pin.png',
    iconImageSize: [0, 0],
    iconImageOffset: [0, 0]
  },
  PIN_CIRCLE_RESIZER: {
    draggable: true,
    iconLayout: 'default#image',
    iconImageHref: '/static/images/polygon_vertex_pin_start.svg',
    iconImageSize: [30, 30],
    iconImageOffset: [-15, -15]
  }
});

angular.module('cian.mapDraw')
.filter('declension', function() {
  return function(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
  };
});

angular.module('cian.mapDraw')
.directive("drawing", ["$window", function($window){
  return {
    scope: {
      onDrawingFinished: '&'
    },
    restrict: 'A',
    link: function(scope, element, attrs){
      var options = {
        belowElem: '.search-map'
      };

      var points = [];

      var ctx = element[0].getContext('2d');

      // variable that decides if something should be drawn on mousemove
      var drawing = false;

      // the last coordinates before the current move
      let lastCoords;

      let canvasOffset;

      function getCoordsFromEvent(e, relativeToPage = false) {
        return {
          // touches[0] — for Android
          x: (e.touches ? e.touches[0].pageX : e.pageX) -
            (relativeToPage ? 0 : canvasOffset.left),
          y: (e.touches ? e.touches[0].pageY : e.pageY) -
            (relativeToPage ? 0 : canvasOffset.top),
        };
      }

      angular.element($window).bind('resize', _onResize);
      _onResize();

      function _onResize() {
        attrs.$set('width', angular.element(options.belowElem).width());
        attrs.$set('height', angular.element(options.belowElem).height());
      }

      element.bind('mousedown touchstart', function(event){
        // Чтобы не подсвечивалась карта при клике на iOS
        event.preventDefault();

        canvasOffset = element.parent().offset();

        lastCoords = getCoordsFromEvent(event);

        // begins new line
        ctx.beginPath();

        drawing = true;
      });
      element.bind('mousemove touchmove', event => {
        if (drawing) {
          // Чтобы не скролилась карта
          event.preventDefault();

          // get current mouse position
          const currentCoords = getCoordsFromEvent(event);

          draw(lastCoords, currentCoords);

          // save path coordinates
          const coordsRelativeToPage = getCoordsFromEvent(event, true);
          points.push([
            coordsRelativeToPage.x,
            coordsRelativeToPage.y,
          ]);

          // set current coordinates to last one
          lastCoords = currentCoords;
        }
      });
      element.bind('mouseup touchend', () => {
        // stop drawing
        drawing = false;
        scope.onDrawingFinished({mouseCoordsArray: points});
        reset();
      });

      // canvas reset
      function reset(){
       element[0].width = element[0].width;
       points = [];
      }

      function draw(from, to){
        // line from
        ctx.moveTo(from.x, from.y);
        // to
        ctx.lineTo(to.x, to.y);
        // color
        ctx.strokeStyle = "#DB1D1D";
        ctx.lineWidth = 3;
        // draw it
        ctx.stroke();
      }
    }
  };
}]);



// WEBPACK FOOTER //
// ./src/components/map-draw/src/scripts/cian.map-draw.js